import { render, staticRenderFns } from "./index.vue?vue&type=template&id=27ec71ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=27ec71ee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ec71ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ec71ee')) {
      api.createRecord('27ec71ee', component.options)
    } else {
      api.reload('27ec71ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=27ec71ee&scoped=true", function () {
      api.rerender('27ec71ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/sportEvent/index.vue"
export default component.exports